import React from 'react';

import { useNotifications } from '../hooks/useNotifications.hook';
import { NotificationsContext } from './NotificationContext';

export const NotificationsProvider = ({ children }) => {
  const values = useNotifications();
return (
    <NotificationsContext.Provider value={values}>
      {children}
    </NotificationsContext.Provider>
  );
};
